import { render, staticRenderFns } from "./videoChater.vue?vue&type=template&id=3c75dbe0&scoped=true"
import script from "./videoChater.vue?vue&type=script&lang=js"
export * from "./videoChater.vue?vue&type=script&lang=js"
import style0 from "./videoChater.vue?vue&type=style&index=0&id=3c75dbe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c75dbe0",
  null
  
)

export default component.exports